import React, { useState, useEffect, useContext } from "react";
import {
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Input,
  InputGroup,
} from "reactstrap";
import { useController, useForm } from "react-hook-form";
import { Button } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Select from "react-select";
import {
  createCarType,
  getAllCarType,
  updateCarType,
} from "../../../Services/Car.service";
import { showAlert } from "../../../Services/Shared.service";


function CarTypeForm({carTypeList,isSearch, setIsSearch,triggerRefresh}) {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm({
    defaultValues: {},
  });

  const [isEdit, setIsEdit] = useState(false);
  const [selectedCarType, setSelectedCarType] = useState();

  const handleNewClick = () => {
    setIsEdit(false);
    setIsSearch(false);
    reset({
      name: "",
      description: "",
      iconUrl: "",
      seatCount: "",
      passCount: "",
      bagCount: "",
    });
  };

  const handleExistClick = (carType) => {
    setIsEdit(true)
    console.log("carType selected", carType);
    reset({
      name: carType ? carType.value.name : "",
      description: carType ? carType.value.description : "",
      iconUrl: carType ? carType.value.iconUrl : "",
      seatCount: carType ? carType.value.noOfSeats : "",
      passCount: carType ? carType.value.noOfPassenger : "",
      bagCount: carType ? carType.value.noOfBags : "",
    });
    setIsSearch(false);
    setSelectedCarType(carType);
  };

  const handleLog = (formvalues) => {
    console.log("Formvalues", formvalues);
  };

  const handleCarTypeSubmit = (formvalues) => {
    const body = {
      name: formvalues ? formvalues.name : "",
      noOfSeats: formvalues ? formvalues.seatCount : "",
      description: formvalues ? formvalues.description : "",
      noOfBags: formvalues ? formvalues.bagCount : "",
      iconUrl: formvalues ? formvalues.iconUrl : "",
      noOfPassenger:formvalues ? formvalues.passCount:"",

    };
    if (isEdit) {
      body["id"] = selectedCarType.value.id;
      updateCarType(body)
        .then((resp) => {
          showAlert("success", "CarType updated successfully");
          setIsSearch(true);
          triggerRefresh()
        })
        .catch((err) => {
          showAlert("error", "Something went wrong");
        });
    } else {
      createCarType(body)
        .then((resp) => {
          if (resp.status == 200) {
            showAlert("success", "CarType Created Successfully");
          }
          reset({
            name: "",
            description: "",
            iconUrl: "",
            seatCount: "",
            passCount: "",
            bagCount: "",
          })
          setIsSearch(true);
        triggerRefresh()
        })
        .catch((err) => {
          showAlert("error", "Something went wrong on create");
        });
    }
  };

  return (
    <div>
      {isSearch ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "400px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Button
              sx={{
                width: "100%",
                fontSize: "1rem",
                color: "#41CC7D",
                borderColor: "#41CC7D",
                "&:hover": {
                  borderColor: "#41CC7D",
                },
              }}
              variant="outlined"
              startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
              onClick={() => {
                handleNewClick();
              }}
            >
              New Car Type
            </Button>

            <Select
              options={carTypeList}
              onChange={(e) => handleExistClick(e)}
              cacheOptions
              placeholder={"Select Car Type"}
            />
          </div>
        </div>
      ) : (
        <Form onSubmit={handleSubmit(handleCarTypeSubmit)}>
          <Row>
            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Name</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("name", {
                    required: {
                      value: true,
                      message: "name is required",
                    },
                    onChange: (e) => {
                      setValue("name", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>{errors?.name?.message}</span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Description</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("description", {
                    required: {
                      value: true,
                      message: "description is required",
                    },
                    onChange: (e) => {
                      setValue("description", e.target.value.trimStart());
                    },
                  })}
                />

                <span style={{ color: "red" }}>
                  {errors?.description?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Icon URL</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="text"
                  {...register("iconUrl", {
                    required: {
                      value: true,
                      message: "iconUrl is required",
                    },
                    onChange: (e) => {
                      setValue("iconUrl", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>{errors?.iconUrl?.message}</span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">
                No.Of.Passengers
              </Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="number"
                  maxLength={2}
                  {...register("passCount", {
                    required: {
                      value: true,
                      message: "passCount is required",
                    },
                    onChange: (e) => {
                      setValue("passCount", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.passCount?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">No.Of.Seats</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="number"
                  maxLength={2}
                  {...register("seatCount", {
                    required: {
                      value: true,
                      message: "seatCount is required",
                    },
                    onChange: (e) => {
                      setValue("seatCount", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.seatCount?.message}
                </span>
              </Col>
            </FormGroup>

            <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">No.Of.Bags</Label>
              <Col lg="12">
                <input
                  className="form-control"
                  type="number"
                  maxLength={2}
                  {...register("bagCount", {
                    required: {
                      value: true,
                      message: "bagCount is required",
                    },
                    onChange: (e) => {
                      setValue("bagCount", e.target.value.trimStart());
                    },
                  })}
                />
                <span style={{ color: "red" }}>
                  {errors?.bagCount?.message}
                </span>
              </Col>
            </FormGroup>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="submit"
                className="btn submit-button"
                // disabled={isSubmitting}
              >
                {isEdit?"Update":"Create"}
              </button>
            </div>
          </Row>
        </Form>
      )}
    </div>
  );
}

export default CarTypeForm;
